<svg viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_7753_5195)">
<path d="M16.5506 2.19725L14.1361 13.3562C13.9539 14.1438 13.4789 14.3398 12.8038 13.9688L9.12494 11.3121L7.34978 12.9852C7.15334 13.1777 6.98903 13.3387 6.61043 13.3387L6.87474 9.66692L13.6932 3.62888C13.9897 3.36985 13.6289 3.22634 13.2324 3.48536L4.80313 8.68683L1.17423 7.57373C0.384875 7.33221 0.370588 6.80016 1.33853 6.42913L15.5327 1.07015C16.1899 0.828628 16.7649 1.21366 16.5506 2.19725Z"/>
</g>
<defs>
<clipPath id="clip0_7753_5195">
<rect width="16" height="16" fill="white" transform="translate(0.596191 0.00012207)"/>
</clipPath>
</defs>
</svg>
